/**
 *  Impulse Plugin JS File
 */
( function () {

    updateAddressBar();
    const locked = document.querySelectorAll( '.locked' );

    if ( locked.length ) {
        for ( let l of locked ) {
            l.addEventListener( 'click', ( ev ) => {
                ev.preventDefault();

                // @TODO: popup/info whatever when clicking locked impulse
            } );
        }
    }

    /** Remove auth token from address bar */
    function updateAddressBar() {
        if ( history.pushState ) {
            const uri = window.location.toString();
            const cleaned_uri = uri.substring( 0, uri.indexOf( '?' ) );

            window.history.pushState( { path: cleaned_uri } , '', cleaned_uri );
        }
    }
} ) ();
